import {IModalServiceInstance} from 'angular-ui-bootstrap';
import ITranslateService = angular.translate.ITranslateService;

export class RemoveDialogController {

    static $inject = ['$uibModalInstance', '$translate', 'title', 'text'];

    deleteText: string;
    title: string;

    constructor(private $uibModalInstance: IModalServiceInstance, $translate: ITranslateService, title: string, text: string) {
        if (text !== undefined && text !== null) {
            this.deleteText = $translate.instant(text);
        } else {
            this.deleteText = $translate.instant('LOESCHEN_DIALOG_TEXT');
        }

        if (title !== undefined && title !== null) {
            this.title = $translate.instant(title);

        } else {
            this.title = $translate.instant('LOESCHEN_DIALOG_TITLE');
        }
    }

    public hide(): void {
        return this.$uibModalInstance.close();
    }

    cancel(): void {
        this.$uibModalInstance.dismiss('cancel');
    };
}



// WEBPACK FOOTER //
// ./src/app/core/dialog/RemoveDialogController.ts